import { makeStyles } from '@material-ui/core';
import { Mixin } from '@monorepo/common';
import { TOKENS } from '../../styles/tokens';

export const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '2rem',
    ...Mixin.mixin.flex('flex-start', 'center'),
    '@media(max-width: 1200px)': {
      display: 'block'
    }
  },
  wrapper_card: {
    padding: '40px 20px',
    position: 'relative',
    borderRadius: theme.shape.borderRadius
  },
  description_page: {
    '& h1': {
      textAlign: 'center'
    },
    '& p, & b,& li': {
      fontSize: 16
    },
    '& ul': {
      paddingLeft: '1.3rem'
    },
    '& p, & ul': {
      marginBottom: '1rem'
    },
    '& li': {
      marginBottom: '.7rem'
    },
  },
  table_wrapper: {
    maxWidth: '100%',
    overflowX: 'auto',
    ...Mixin.mixin.br()
  },
  link: {
    color: theme.palette.error.main
  },
  wrapper_for_steps: {
    width: '100%',
    maxWidth: '50rem',
    '& .MuiAvatar-root': {
      backgroundColor: '#e21836'
    },
    '@media(max-width: 1200px)': {
      maxWidth: '100%',
    }
  },
  active_step: {
    padding: '32px 8px 32px 20px',
    borderLeft: '2px solid rgb(230, 232, 240) !important',
    marginLeft: '20px !important'
  },
  stepper: {
    '& .MuiStepConnector-line': {
      ml: 1,
      borderLeftColor: 'divider',
      borderLeftWidth: 2
    }

  },
  step3_address_wrap: {
    ...Mixin.mixin.flex('flex-start', 'flex-start'),
    gridGap: '2rem',
    marginBottom: '2rem',
    '& > div': {
      flex: 1,
      marginBottom: 0,
      '@media(max-width: 768px)': {
        marginBottom: '2rem'
      }
    },
    '@media(max-width: 768px)': {
      display: 'block'
    }
  },
  left: {
    order: 0
  },
  right: {
    order: 1,
    textAlign: 'center'
  },
  line: {
    ...Mixin.mixin.flex(),
    marginBottom: '0.5rem',
    '& $left': {
      paddingRight: 10,
      width: 'calc(100% - 8rem)'
    },
    '& $right': {
      width: '100%',
      maxWidth: '8rem'
    },
  },
  job_package_title: {
    ...Mixin.mixin.flex('center', 'flex-start'),
    gap: 8,
    '@media(max-width: 992px)': {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  job_package_price: {
    ...Mixin.mixin.flex('center', 'center'),
    gap: 6,
    padding: '0.25rem 0.5rem',
    borderRadius: (theme.shape.borderRadius as number),
    color: TOKENS.accentText,
    backgroundColor: TOKENS.accentSoft,
    '& span': {
      fontSize: '0.75rem',
      lineHeight: '0.75rem',
    }
  },
  job_package_description: {
    color: theme.palette.text.secondary,
  }
}));
